import Lottie from 'lottie-react';
import { Link } from '@tanstack/react-router';

import animationUpload from '@assets/lottie-animation/upload.json';
import { Button } from '@/components/ui/button/button';

export const IncompleteContent = () => {
  return (
    <div className="pb-6">
      <div className="grid min-h-full place-items-center rounded-xl border bg-white px-6 py-24 sm:py-10 lg:px-8">
        <div className="text-center">
          <h3 className="mt-4 text-3xl font-medium tracking-tight text-gray-900 sm:text-5xl">
            Registration Successful
          </h3>
          <p className="mx-auto mt-6 w-[500px] text-base leading-7 font-light text-gray-600">
            To process your account activation, please complete our company's legal documents
            requirements. This information is required to comply with our internal verification.
          </p>

          <Lottie className="mx-auto mt-4 w-[400px]" animationData={animationUpload} loop={true} />

          <div className="space-y-3">
            <p className="text-sm text-gray-700">
              📄 To speed up the process, please complete your business documentation.
            </p>
            <p className="text-sm text-gray-700">
              💬 If you have any questions, feel free to contact our customer service.
            </p>
          </div>

          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button>
              <Link to="/users">Complete Business Document</Link>
            </Button>

            <a href="/" className="flex flex-col text-sm font-medium text-gray-900">
              <span aria-hidden="true">Contact support</span>
              <span aria-hidden="true">hello@doitpay.co</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
